const isValidEmail = (email: string): boolean => {
  const emailRegexp: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegexp.test(email);
};

export default isValidEmail;
